import { render } from "./PolicyGroupForm.vue?vue&type=template&id=aa047c0a"
import script from "./PolicyGroupForm.vue?vue&type=script&lang=js"
export * from "./PolicyGroupForm.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-user-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__